<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.75 4.5V7.5H14.25C13.7325 7.5 13.5 8.1075 13.5 8.625V10.5H15.75V13.5H13.5V19.5H10.5V13.5H8.25V10.5H10.5V7.5C10.5 5.84315 11.8431 4.5 13.5 4.5H15.75Z"
        />
    </svg>
</template>
